import { useState } from 'react'

import { Visibility, VisibilityOff } from '@mui/icons-material'
import {
  FormHelperText,
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
} from '@mui/material'

import { Controller } from 'react-hook-form'

import { FormInputProps } from './FormInputProps'

import styles from './styles.module.scss'

export const FormInputPassword = ({
  name,
  control,
  defaultValue,
  validate,
  label,
  id,
  ...rest
}: FormInputProps & TextFieldProps) => {
  const [showPassword, setShowPassword] = useState<boolean>(false)

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange }, fieldState }) => {
        return (
          <>
            <TextField
              fullWidth
              type={showPassword ? 'text' : 'password'}
              label={label}
              id={id || name}
              defaultValue=""
              size="small"
              onChange={onChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={togglePasswordVisibility}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              {...rest}
            />
            {fieldState.error && (
              <div className={styles.containerError}>
                <FormHelperText error sx={{ lineHeight: '1rem', marginTop: 0 }}>
                  *{fieldState.error.message}
                </FormHelperText>
              </div>
            )}
          </>
        )
      }}
      defaultValue={defaultValue}
      rules={validate}
    />
  )
}
